import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextQuillField, {
  MxFormTextQuillFieldProps
} from "@rf-l2/form/text-fields/MxFormTextQuillField";
interface MxFormL3TextQuillFieldProp extends MxFormTextQuillFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3TextQuillField = (props: MxFormL3TextQuillFieldProp) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormTextQuillField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3TextQuillField;
